
window.addEventListener("load", (event) => {

   const currentUrl = window.location.href;
    // Set the URL as the value of the input with id 'product-url'
    document.getElementById('product-url').value = currentUrl;
  
 const productTitleHTML = document.querySelector('.custom_product_title_main')?.innerHTML;
    
    if (productTitleHTML) {
        // Remove extra whitespace from the title
        const cleanTitle = productTitleHTML.replace(/\s+/g, ' ').trim();
        // Set the cleaned title as the value of the input with id 'product-title'
        document.getElementById('product-title').value = cleanTitle;
    }
  
  
  document.querySelector('.cstm_sample_btn').addEventListener('click', function(e) {

   
    
    e.preventDefault();
document.querySelector('#shopify-section-template--20799951405268__featured_product_4xtxXt .product-form__buttons-row button[type="submit"]').click();
    
    
  });
});


/* ===== Sample button label: drop the hardcoded price (2026-07-27) =====
   The price is baked into the markup in sections/main-product.liquid.
   Rewriting it here keeps the label in one place and survives theme updates. */
window.addEventListener("load", function () {
  var SAMPLE_LABEL = 'Order a sample';

  function relabelSampleButtons() {
    var buttons = document.querySelectorAll('.cstm_sample_btn');
    buttons.forEach(function (btn) {
      if (btn.dataset.labelFixed === 'true') return;

      if (btn.tagName === 'INPUT') {
        btn.value = SAMPLE_LABEL;
      } else {
        btn.textContent = SAMPLE_LABEL;
      }

      btn.setAttribute('aria-label', SAMPLE_LABEL);
      btn.dataset.labelFixed = 'true';
    });
  }

  relabelSampleButtons();

  // Re-apply if the theme re-renders the buy buttons (variant change, quick view, etc.)
  var target = document.querySelector('main') || document.body;
  if (window.MutationObserver && target) {
    new MutationObserver(relabelSampleButtons).observe(target, {
      childList: true,
      subtree: true
    });
  }
});
